import { noNaN } from '@apia/util';
import { makeCellKey } from './keysMaker';
import { TIconsListOperation, TState } from './types';

function assignSelectedIndexId(state: TState) {
  const element = document.querySelector(
    `#${state.storeId} [aria-rowindex="${state.focusedRow}"] [aria-colindex="${state.focusedColumn}"]`,
  );

  if (element instanceof HTMLElement) {
    state.focusedId = element.dataset.id as string;
  }
}

const arrowDown: TIconsListOperation<void> = (state: TState, _: void, keys) => {
  if (
    !document.querySelector(
      `#${state.storeId} [aria-rowindex="${
        state.focusedRow + 1
      }"] [aria-colindex="${state.focusedColumn}"]`,
    )
  )
    return;

  keys.set([
    makeCellKey({
      columnIndex: state.focusedColumn,
      rowIndex: state.focusedRow,
    }),
    makeCellKey({
      columnIndex: state.focusedColumn,
      rowIndex: state.focusedRow + 1,
    }),
    'grid',
  ]);
  state.focusedRow++;

  assignSelectedIndexId(state);
};
const arrowUp: TIconsListOperation<void> = (state, _: void, keys) => {
  if (state.focusedRow > 1) {
    keys.set([
      makeCellKey({
        columnIndex: state.focusedColumn,
        rowIndex: state.focusedRow,
      }),
      makeCellKey({
        columnIndex: state.focusedColumn,
        rowIndex: state.focusedRow - 1,
      }),
      'grid',
    ]);
    state.focusedRow--;

    assignSelectedIndexId(state);
  }
};
const arrowLeft: TIconsListOperation<void> = (state, _: void, keys) => {
  if (state.focusedColumn > 1) {
    keys.set([
      makeCellKey({
        columnIndex: state.focusedColumn,
        rowIndex: state.focusedRow,
      }),
      makeCellKey({
        columnIndex: state.focusedColumn - 1,
        rowIndex: state.focusedRow,
      }),
      'grid',
    ]);
    state.focusedColumn--;

    assignSelectedIndexId(state);
  }
  /**
   * Este bloque agrega el comportamiento de que, al presionar la flecha
   * derecha estando en el último ícono de una fila, salta a la fila
   * siguiente. El problema es que solamente funciona cuando las ids son
   * secuenciales, lo cual no siempre es cierto. Habría que agregar un sistema
   * de doble id para garantizar la secuencialidad de las ids usadas por este
   * método, independientemente de las ids provistas por el usuario del
   * componente.
   */
  /* else if (state.focusedRow > 1) {
    const focusedRow = document.querySelector(
      `#${state.storeId} [aria-rowindex="${state.focusedRow - 1}"]`,
    );

    if (focusedRow instanceof HTMLElement) {
      const colIndex = noNaN(
        focusedRow.querySelector('[aria-colIndex]:last-of-type')?.ariaColIndex,
        -1,
      );

      if (colIndex !== -1) {
        keys.set([
          makeCellKey({
            columnIndex: state.focusedColumn,
            rowIndex: state.focusedRow,
          }),
          makeCellKey({
            columnIndex: colIndex,
            rowIndex: state.focusedRow - 1,
          }),
          'grid',
        ]);

        state.focusedRow--;
        state.focusedColumn = colIndex;

        assignSelectedIndexId(state);
      }
    }
  } */
};
const arrowRight: TIconsListOperation<void> = (state, _: void, keys) => {
  if (
    !document.querySelector(
      `#${state.storeId} [aria-rowindex="${
        state.focusedRow
      }"] [aria-colindex="${state.focusedColumn + 1}"]`,
    )
  ) {
    /**
     * Este bloque agrega el comportamiento de que, al presionar la flecha
     * derecha estando en el último ícono de una fila, salta a la fila
     * siguiente. El problema es que solamente funciona cuando las ids son
     * secuenciales, lo cual no siempre es cierto. Habría que agregar un sistema
     * de doble id para garantizar la secuencialidad de las ids usadas por este
     * método, independientemente de las ids provistas por el usuario del
     * componente.
     */
    /* const newFocusedId = noNaN(state.focusedId) + 1;
    const element = document.querySelector(
      `#${state.storeId} [data-id="${newFocusedId}"]`,
    );

    if (element instanceof HTMLElement) {
      const rowIndex = noNaN(
        element.closest('[aria-rowindex]')?.ariaRowIndex,
        -1,
      );
      const colIndex = noNaN(
        element.closest('[aria-colindex]')?.ariaColIndex,
        -1,
      );

      if (rowIndex !== -1 && colIndex !== -1) {
        keys.set([
          makeCellKey({
            columnIndex: state.focusedColumn,
            rowIndex: state.focusedRow,
          }),
          makeCellKey({
            columnIndex: colIndex,
            rowIndex: rowIndex,
          }),
          'grid',
        ]);

        state.focusedColumn = colIndex;
        state.focusedRow = rowIndex;

        assignSelectedIndexId(state);
      }
    } */

    return;
  }
  keys.set([
    makeCellKey({
      columnIndex: state.focusedColumn,
      rowIndex: state.focusedRow,
    }),
    makeCellKey({
      columnIndex: state.focusedColumn + 1,
      rowIndex: state.focusedRow,
    }),
    'grid',
  ]);
  state.focusedColumn++;
  assignSelectedIndexId(state);
};
const setFocused: TIconsListOperation<{
  rowIndex: number;
  colIndex: number;
}> = (state, payload, keys) => {
  if (
    !document.querySelector(
      `#${state.storeId} [aria-rowindex="${payload.rowIndex}"] [aria-colindex="${payload.colIndex}"]`,
    )
  )
    return;

  keys.set([
    makeCellKey({ columnIndex: payload.colIndex, rowIndex: payload.rowIndex }),
    makeCellKey({
      columnIndex: state.focusedColumn,
      rowIndex: state.focusedRow,
    }),
    'grid',
  ]);

  state.focusedColumn = payload.colIndex;
  state.focusedRow = payload.rowIndex;

  assignSelectedIndexId(state);
};

const recalculateIndexByResize: TIconsListOperation<void> = (
  state: TState,
  _: void,
  keys,
) => {
  const element = document.querySelector(
    `#${state.storeId} [data-id="${state.focusedId}"]`,
  );

  if (element instanceof HTMLElement) {
    const rowIndex = noNaN(
      element.closest('[aria-rowindex]')?.ariaRowIndex,
      -1,
    );
    const colIndex = noNaN(
      element.closest('[aria-colindex]')?.ariaColIndex,
      -1,
    );

    if (rowIndex !== -1 && colIndex !== -1) {
      keys.set([
        makeCellKey({
          columnIndex: state.focusedColumn,
          rowIndex: state.focusedRow,
        }),
        makeCellKey({ columnIndex: colIndex, rowIndex }),
      ]);

      state.focusedColumn = colIndex;
      state.focusedRow = rowIndex;
    }
  }
};

export const operations = {
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  setFocused,
  recalculateIndexByResize,
};
